document.addEventListener("DOMContentLoaded", () => {
  const STORAGE_KEY = "custom_wishlist";
  const wishlistContainer = document.getElementById("wishlist-products-container");
  const wishlistEmpty = document.getElementById("wishlist-empty");
  const clearBtn = document.getElementById("wishlist-clear-btn");
  const atcBtn = document.querySelector(".wishlist-all-products-atc-button");
  const wishlistCountEls = document.querySelectorAll(".wishlist-icon-count");
  const actionBtns = Array.from(document.querySelectorAll(".wishlist-action-btn"));
  const heartBtns = Array.from(document.querySelectorAll(".wishlist-btn"));

  const listBtn = document.getElementById("btn-list-view");
  const grid2Btn = document.getElementById("btn-grid-2");
  const grid3Btn = document.getElementById("btn-grid-3");
  const grid4Btn = document.getElementById("btn-grid-4");
  const grid5Btn = document.getElementById("btn-grid-5");

  const mobileLayouts = ["list", "grid2"];
  const defaultMobileLayout = "grid2";
  const defaultDesktopLayout = "grid4";

  const getWishlist = () => JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  const setWishlist = (items) => localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

  const updateCount = () => {
    const count = getWishlist().length;
    wishlistCountEls.forEach(el => el.textContent = count);
  };

  const toggleButtonsUI = () => {
    const items = getWishlist();

    actionBtns.forEach(btn => {
      const handle = btn.getAttribute("data-product-handle");
      const label = btn.querySelector(".wishlist-label");
      const icon = btn.querySelector("svg");

      if (handle && label && icon) {
        if (items.includes(handle)) {
          label.textContent = "Delete from Wishlist";
          btn.classList.add("active");
          btn.setAttribute("aria-pressed", "true");
          icon.classList.add("fa-solid", "text-red-500");
          icon.classList.remove("fa-regular");
        } else {
          label.textContent = "Add to Wishlist";
          btn.classList.remove("active");
          btn.setAttribute("aria-pressed", "false");
          icon.classList.remove("fa-solid", "text-red-500");
          icon.classList.add("fa-regular");
        }
      }
    });

    heartBtns.forEach(btn => {
      const handle = btn.getAttribute("data-handle");
      const icon = btn.querySelector("svg");

      if (handle && icon) {
        if (items.includes(handle)) {
          console.log("Clicking on Button")
          btn.classList.add("active");
          btn.setAttribute("aria-pressed", "true");
          icon.classList.add("fa-solid", "text-red-500");
          icon.classList.remove("fa-regular");
        } else {
          btn.classList.remove("active");
          btn.setAttribute("aria-pressed", "false");
          icon.classList.remove("fa-solid", "text-red-500");
          icon.classList.add("fa-regular");
        }
      }
    });
  };

  const updateWishlistView = () => {
    const items = getWishlist();
    if (!wishlistContainer || !wishlistEmpty) return;

    // Show/hide empty message and clear button
    wishlistContainer.style.display = items.length ? "grid" : "none";
    wishlistEmpty.style.display = items.length ? "none" : "block";
    if (clearBtn) clearBtn.style.display = items.length ? "inline-block" : "none";
    if (atcBtn) atcBtn.style.display = items.length ? "inline-block" : "none";
    // Remove all non-wishlist products from the DOM
    Array.from(wishlistContainer.children).forEach(child => {
      const handle = child.dataset.handle;
      if (!items.includes(handle)) {
        wishlistContainer.removeChild(child);
      }
    });
  };

  const toggleWishlist = (handle) => {
    let items = getWishlist();
    items = items.includes(handle) ? items.filter(h => h !== handle) : [...items, handle];
    setWishlist(items);
    updateCount();
    updateWishlistView();
    toggleButtonsUI();
  };

  actionBtns.forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const handle = btn.getAttribute("data-product-handle");
      if (handle) toggleWishlist(handle);
    });
  });

  heartBtns.forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const handle = btn.getAttribute("data-handle");
      if (handle) toggleWishlist(handle);
    });
  });

  clearBtn?.addEventListener("click", () => {
    localStorage.removeItem(STORAGE_KEY);
    updateCount();
    updateWishlistView();
    toggleButtonsUI();
  });

  // Layout controls
  const removeLayoutClass = () => {
    [listBtn, grid2Btn, grid3Btn, grid4Btn, grid5Btn].forEach(btn => {
      btn?.classList.remove("active");
      btn?.setAttribute("aria-pressed", "false");
    });
  };

  const applyLayout = (layout) => {
    wishlistContainer?.classList.remove("wishlist-list", "wishlist-grid-2", "wishlist-grid-3", "wishlist-grid-4", "wishlist-grid-5");
    if (layout === "list") wishlistContainer?.classList.add("wishlist-list");
    if (layout === "grid2") wishlistContainer?.classList.add("wishlist-grid-2");
    if (layout === "grid3") wishlistContainer?.classList.add("wishlist-grid-3");
    if (layout === "grid4") wishlistContainer?.classList.add("wishlist-grid-4");
    if (layout === "grid5") wishlistContainer?.classList.add("wishlist-grid-5");
  };

  let currentLayout = defaultDesktopLayout;
  applyLayout(currentLayout);
  removeLayoutClass();

  const markActiveLayout = (layout) => {
    removeLayoutClass();
    if (layout === "list") listBtn?.classList.add("active"), listBtn?.setAttribute("aria-pressed", "true");
    if (layout === "grid2") grid2Btn?.classList.add("active"), grid2Btn?.setAttribute("aria-pressed", "true");
    if (layout === "grid3") grid3Btn?.classList.add("active"), grid3Btn?.setAttribute("aria-pressed", "true");
    if (layout === "grid4") grid4Btn?.classList.add("active"), grid4Btn?.setAttribute("aria-pressed", "true");
    if (layout === "grid5") grid5Btn?.classList.add("active"), grid5Btn?.setAttribute("aria-pressed", "true");
  };

  markActiveLayout(currentLayout);

  const bindLayoutBtn = (btn, layout) => {
    btn?.addEventListener("click", () => {
      currentLayout = layout;
      applyLayout(currentLayout);
      markActiveLayout(currentLayout);
    });
  };

  bindLayoutBtn(listBtn, "list");
  bindLayoutBtn(grid2Btn, "grid2");
  bindLayoutBtn(grid3Btn, "grid3");
  bindLayoutBtn(grid4Btn, "grid4");
  bindLayoutBtn(grid5Btn, "grid5");

  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleResponsiveLayout = () => {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      listBtn && (listBtn.style.display = "inline-block");
      grid2Btn && (grid2Btn.style.display = "inline-block");
      [grid3Btn, grid4Btn, grid5Btn].forEach(btn => btn && (btn.style.display = "none"));
      if (!mobileLayouts.includes(currentLayout)) {
        currentLayout = defaultMobileLayout;
        applyLayout(currentLayout);
        markActiveLayout(currentLayout);
      }
    } else {
      listBtn && (listBtn.style.display = "none");
      grid2Btn && (grid2Btn.style.display = "none");
      [grid3Btn, grid4Btn, grid5Btn].forEach(btn => btn && (btn.style.display = "inline-block"));
      if (mobileLayouts.includes(currentLayout)) {
        currentLayout = defaultDesktopLayout;
        applyLayout(currentLayout);
        markActiveLayout(currentLayout);
      }
    }
  };

  handleResponsiveLayout();
  window.addEventListener("resize", debounce(handleResponsiveLayout, 150));

  updateCount();
  updateWishlistView();
  toggleButtonsUI();
document.addEventListener("click", function (e) {
  console.log('clicking on remove button')
  const btn = e.target.closest('.wishlist-btn.active[aria-label="Remove from Wishlist"]');
  if (!btn) return;

  const handle = btn.getAttribute("data-handle");
  if (!handle) return;

  let wishlist = JSON.parse(localStorage.getItem("custom_wishlist") || "[]");
  wishlist = wishlist.filter(h => h !== handle);
  localStorage.setItem("custom_wishlist", JSON.stringify(wishlist));

  updateCount();
  updateWishlistView();
  toggleButtonsUI();
});
});


